import { getUploadToken, upload2qn, getSuffix, blobToBase64 } from './Utils'
import * as axios from 'axios'
import PSD from 'psd.js'
import moment from 'dayjs'

// 图片转换api
const imgApi = 'https://api.shareuc.com/resize'
const downUrl = 'https://shareucm.shareuc.com'
const bucket = 'source/'

class ConvertFile {
  constructor (file, callback) {
    this.valideFileBase = ['.jpg', '.jpeg', '.png', '.avif', '.psd']
    this.validFileTypesApi = ['.jpg', '.jpeg', '.png', '.webp', '.bmp', '.gif', '.tiff', '.pdf', '.ai']
    this.validFileTypesAli = ['.jpg', '.jpeg', '.png', '.webp', '.bmp', '.gif', '.tiff']
    this.validFileTypesQiniu = ['.jpg', '.jpeg', '.png', '.webp', '.bmp', '.gif', '.tiff']
    this.file = file
    this.callback = callback
    if (file) {
      this.suffix = getSuffix(file.name)
      console.log('文件后缀', this.suffix)
      this.name = moment().format('YYYYMMDDHHmmss') + this.suffix
    }
  }

  start () {
    this.inputChange(this.file)
  }

  parsePSD (file) {
    var url = URL.createObjectURL(file)
    PSD.fromURL(url).then((psd) => {
      const base64 = psd.image.toBase64()
      if (this.callback) {
        this.callback({
          msg: 'success',
          data: base64,
          name: this.name
        })
      }
      URL.revokeObjectURL(url)
    })
  }

  readFile (file) {
    var reader = new FileReader()
    reader.onload = (e) => {
      if (this.callback) {
        this.callback({
          msg: 'success',
          data: e.target.result,
          name: this.name
        })
      }
    }
    reader.readAsDataURL(file)
  }

  isFileValid (file) {
    if (typeof file === 'undefined') return false
    if (this.valideFileBase.indexOf(this.suffix) === -1 && this.validFileTypesApi.indexOf(this.suffix) === -1 && this.validFileTypesAli.indexOf(this.suffix) === -1) {
      return false
    }
    // 判断大小是否超过30m
    if (file.size > 30 * 1024 * 1024) {
      return false
    }
    if (file.size > 20 * 1024 * 1024 && this.validFileTypesApi.indexOf(this.suffix) === -1) {
      return false
    }
    return true
  }

  async inputChange (file) {
    const valid = this.isFileValid(file)
    if (!valid) {
      if (this.callback) {
        this.callback({
          msg: 'invalid'
        })
      }
      return
    }
    // 1.本地处理
    if (this.valideFileBase.indexOf(this.suffix) > -1) {
      console.log('1.本地转换')
      if (this.suffix === '.psd') {
        this.parsePSD(file)
      } else {
        this.readFile(file)
      }
      return
    }
    // 2.oss或者api转换
    // 处理图片
    var api = false
    // 云服务器转换不了的使用api转换
    if (this.validFileTypesQiniu.indexOf(this.suffix) === -1) {
      api = true
    }
    // 大于20M，用服务器转换
    if (file.size >= 20 * 1024 * 1024) {
      api = true
    }
    // 上传到云服务器
    await this.uploadFile(bucket + this.name, file)
    let url = ''
    if (!api) {
      url = downUrl + '/' + bucket + this.name + '?imageMogr2/thumbnail/1024x/format/jpg'
      console.log('2.使用云存储转换:', url)
    } else {
      // 3.使用API转换
      let temp = ''
      temp = downUrl + '/' + bucket + this.name
      url = imgApi + '?width=1024&type=png&url=' + temp
      console.log('3.使用API转换:', url)
    }
    // 监视进度
    axios({
      method: 'get',
      responseType: 'blob',
      url
    }).then(async (res) => {
      if (res.status === 200) {
        if (this.callback) {
          const base64 = await blobToBase64(res.data)
          this.callback({
            msg: 'success',
            data: base64,
            name: this.name
          })
        }
      } else {
        if (this.callback) {
          this.callback({
            msg: 'fail',
            data: 'download fail'
          })
        }
      }
    })
  }

  async uploadFile (key, blob) {
    const token = await getUploadToken()
    var fd = new FormData()
    fd.append('key', key)
    fd.append('token', token)
    fd.append('file', blob)
    await upload2qn(fd)
  }
}
export default ConvertFile
